module.exports = __webpack_public_path__ + "static/media/ZEEL_F1.85058dd3.txt";